import { Box } from "@twilio-paste/core/box";
import React from "react";

export const GetStartedCardIllustration: React.FC = ({ children }) => <Box marginBottom="space70">{children}</Box>;
